<template>
  <v-navigation-drawer
    absolute
    dark
    app
    permanent
    mini-variant-width="100"
    :mini-variant="true"
    stateless
    class="navigation-drawer"
  >
    <v-row>
      <v-img
        :src="require('@/assets/logo_v2.png')"
        id="drawer-logo"
        contain
      />
    </v-row>

    <v-divider />

    <v-list>
      <v-tooltip
        right
        v-for="(tabData, tab, i) in tabsCanAccess"
        :key="i"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-list-item
            link
            @click="handleClickTab(tab)"
            color="rgb(255, 149, 24)"
            :to="tabData.to ? tabData.to : null"
            :class="{'v-list-item--active': tabData.isActive}"
            v-bind="attrs"
            v-on="on"
          >
            <v-badge
              :content="`${tabData.badgeNumber}`"
              style="z-index: 1000000 !important;"
              color="orange"
              overlap
              offset-x="25"
              offset-y="25"
              :value="drawerName === 'whiteboard' && tabData.badgeNumber !== undefined"
            >
              <v-list-item-icon>
                <v-icon x-large>{{ tabData.icon }}</v-icon>
              </v-list-item-icon>
            </v-badge>

            <v-list-item-content>
              <v-list-item-title>{{ tabData.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ tabData.text }}</span>
      </v-tooltip>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'BaseDrawer',

  props: {
    drawerName: {
      type: String
    },
    miniVariant: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    // background: linear-gradient(120deg, rgba(0,0,0,0.1), rgba(100,100,100,0.1))
  }),

  computed: {
    ...mapState({
      participants: state => state.canvas.participants,
      userInfo: state => state.auth.userInfo
    }),
    tabs () {
      return this.$store.state.tabs[this.drawerName]
    },
    tabsCanAccess () {
      if (!this.userInfo.account.systemAdmin && !this.userInfo.account.globalCofacilitator) {
        // get unpriveleged keys from tabs object
        const allowedKeys = Object.keys(this.tabs).filter(k => {
          return !this.tabs[k].privileged
        })
        // filter the object using the keys
        const filtered = Object.keys(this.tabs)
          .filter(key => allowedKeys.includes(key))
          .reduce((obj, key) => {
            obj[key] = this.tabs[key]
            return obj
          }, {})
        return filtered
      }
      return this.tabs
    }
  },

  methods: {

    handleClickTab (tab) {
      console.log('clicked', tab)

      this.setTab({ drawerName: this.drawerName, tabName: tab })
    },

    ...mapMutations([
      'setTab'
    ])
  },

  mounted () {
    // console.log('TABS')
    // console.log(this.drawerName)
    // console.log(this.tabs)
  }

}
</script>

<style lang="sass" scoped>
  .navigation-drawer
    position: fixed
    overflow-y:scroll

  .blur
    backdrop-filter: blur(5px)

  #drawer-logo
    height: 60px
    width: 60px
</style>
